import classNames from "classnames";
import type React from "react";
import "../../css/Tooltip.css";

type Placement =
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right";

type TooltipProp = {
    children: React.ReactNode;
    label: string;
    className?: string;
    placement?: Placement | undefined; // default as top
    hide?: boolean;
};

function Tooltip({ children, label, className, placement, hide = false }: TooltipProp) {
    let placementValue: string;
    switch (placement) {
        case "top":
            placementValue = "web-lib__tooltip--top";
            break;
        case "bottom":
            placementValue = "web-lib__tooltip--bottom";
            break;
        case "bottom-left":
            placementValue = "web-lib__tooltip--bottom-left";
            break;
        case "bottom-right":
            placementValue = "web-lib__tooltip--bottom-right";
            break;
        case "left":
            placementValue = "web-lib__tooltip--left";
            break;
        case "right":
            placementValue = "web-lib__tooltip--right";
            break;
        case "top-left":
            placementValue = "web-lib__tooltip--top-left";
            break;
        case "top-right":
            placementValue = "web-lib__tooltip--top-right";
            break;
        default:
            placementValue = "web-lib__tooltip--top";
    }
    return hide === true ? (
        <div className={className}>{children}</div>
    ) : (
        <div
            className={classNames(className, "web-lib__tooltip", placementValue)}
            data-tooltip={label}
        >
            {children}
        </div>
    );
}

export default Tooltip;
